import { render, staticRenderFns } from "./BudgetException.vue?vue&type=template&id=53385795&"
import script from "./BudgetException.vue?vue&type=script&lang=ts&"
export * from "./BudgetException.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports